export const areaList = ["北海道地方", "東北地方", "関東甲信地方", "東海地方", "北陸地方", "近畿地方", "中国地方", "四国地方", "九州地方", "沖縄地方"]

